//#region src/utils/zod-to-json-schema/parsers/null.ts
function parseNullDef(refs) {
	return refs.target === "openApi3" ? {
		enum: ["null"],
		nullable: true
	} : { type: "null" };
}

//#endregion
export { parseNullDef };
//# sourceMappingURL=null.js.map